/**
 * Created by Alex Aguilar on 5/16/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('itineraryService', itineraryService)

    itineraryService.$inject = ['$http', 'CONFIG', 'messageService'];

    function itineraryService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/itineraries';

        var service = {
            getItineraries: getItineraries,
            getItinerariesPage: getItinerariesPage,
            getItinerariesDisable: getItinerariesDisable,
            getAllItineraries: getAllItineraries,
            saveItinerary: saveItinerary,
            updateItinerary: updateItinerary,
            getItinerary: getItinerary,
            deleteItinerary: deleteItinerary,
            enableItinerary: enableItinerary,
            getItineraryFlights: getItineraryFlights,
            getRevenuePlan: getRevenuePlan,
            getRevenuePlanMakerModel: getRevenuePlanMakerModel,
            getRevenueByDate: getRevenueByDate,
            getSsrS: getSsrS,
            getRevenueByDateSsr: getRevenueByDateSsr,
            getOverLoad: getOverLoad,
            thereNameItinerary: thereNameItinerary
        };

        return service;

        function getItineraries(){
            return $http.get(urlBase)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded != undefined) ? response.data._embedded.itineraries : [];
            }

            function getFailed(error) {
                messageService.findAllError('');
            }
        }

        function getItinerariesPage(page, size) {
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getItinerariesDisable(){
            return $http.get(urlBase + "/disable")
                .then(function(res){
                    return res
                }, function(error){
                })
        }

        function getAllItineraries(){
            return $http.get(urlBase + "/all")
                .then(function(res){
                    return res
                }, function(error){
                })
        }

        function saveItinerary(itinerary){
            return $http.post(urlBase, itinerary)
                .then(function(){
                    messageService.register('itineraryList');
                }, function(){
                    messageService.registerError();
                });
        }

        function updateItinerary(itinerary, itineraryId){
            return $http.put(urlBase + "/" + itineraryId, itinerary)
                .then(function(){
                    messageService.registerUpdate('itineraryList');
                }, function(){
                    messageService.registerUpdateError();
                })
        }

        function getItinerary(itineraryId){
            return $http.get(urlBase + '/' + itineraryId)
                .then(function(res){
                    return res;
                }, function(){
                    messageService.registerErrorFind('itineraryList');
                })
        }

        function deleteItinerary(itineraryId){
            return $http.delete(urlBase + '/' + itineraryId)
                .then(function(){
                    messageService.registerDisabled('');
                }, function(){
                    messageService.registerDisabledError('');
                })
        }

        function enableItinerary(itineraryId){
            return $http.put(urlBase + '/' + itineraryId + "/enable")
                .then(function(){
                   messageService.registerEnable('');
                }, function(){
                    messageService.registerEnableError('');
                });
        }

        function getItineraryFlights(itineraryId){
            return $http.get(urlBase + '/' + itineraryId + "/flights?detailed=true")
                .then(function(res){
                    return res;
                }, function(error){

                })

        }

        function getRevenuePlan(itineraryId){
            return $http.get(urlBase + '/'+itineraryId+'/revenue/plans')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data._embedded) ? response.data._embedded.routeItineraries : [];
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getRevenuePlanMakerModel(itineraryId,makerId_modelId){
            return $http.get(urlBase + '/'+itineraryId+'/revenue/plans?makerId_modelId='+makerId_modelId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data._embedded) ? response.data._embedded.routeItineraries : [];
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getRevenueByDate(date, aircraftId,page, size) {
            var url = "";
            if (date && !aircraftId) {
                url = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/' + 'flights/date/' + date+'?page=' + page + '&size=' + size;
            } else if (date && aircraftId) {
                url = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/' + 'flights/date/' + date + '?aircraftId=' + aircraftId+'&page=' + page + '&size=' + size;
            }

            return $http.get(url)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                //return (response.data._embedded) ? response.data._embedded.flights : [];
                return (response.data) ? response.data : "";
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getSsrS(detail){
            return $http.get(CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + "/ssrs/list?detailed="+detail)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.ssrs : [];
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

        function getRevenueByDateSsr(date, classificationSsrId,page, size) {
            var url = "";
            if (date && !classificationSsrId) {
                url = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/' + 'flights/date/ssr/' + date+'?page=' + page + '&size=' + size;
            } else if (date && classificationSsrId) {
                url = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/' + 'flights/date/ssr/' + date + '?classificationSsrId=' + classificationSsrId+'&page=' + page + '&size=' + size;
            }

            return $http.get(url).then(getComplete).catch(getFailed);

            function getComplete(response) {
                return (response.data) ? response.data : "";
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getOverLoad(segmentFlightId) {
            var url = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/' + 'segmentFlight/overSoldAll' + '/' + segmentFlightId;
            return $http.get(url)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data) ? response.data : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function thereNameItinerary(name){
            return $http.get(urlBase + "/thereNameItinerary/" + name, {headers: {'Loading-Overlay': false}})
        }
    }
})();
